import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading 
          title={"Explore Breathtaking Destinations Around the World"} 
          subTitle={"Your Adventure Starts Here"} 
          linear 
          sideHeading 
        />
        <Button 
          link={"Destinations"} 
          title={"Explore Now"} 
        />

      </div>
    </section>

  );

};

export default Banner;